export default __webpack_public_path__ + "static/media/accessFluidMonitor.3acd7f6f.png";